// extracted by mini-css-extract-plugin
export default {"root":"speedometr_root__RfsQC","background":"speedometr_background__jyTj+","image":"speedometr_image__2SiCB","arrow":"speedometr_arrow__Yqd8j"};